/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PredicateStringValues } from './PredicateStringValues';
import {
  PredicateStringValuesFromJSON,
  PredicateStringValuesFromJSONTyped,
  PredicateStringValuesToJSON,
  PredicateStringValuesToJSONTyped,
} from './PredicateStringValues';
import type { PredicateIntValues } from './PredicateIntValues';
import {
  PredicateIntValuesFromJSON,
  PredicateIntValuesFromJSONTyped,
  PredicateIntValuesToJSON,
  PredicateIntValuesToJSONTyped,
} from './PredicateIntValues';
import type { V2beta1PredicateOperation } from './V2beta1PredicateOperation';
import {
  V2beta1PredicateOperationFromJSON,
  V2beta1PredicateOperationFromJSONTyped,
  V2beta1PredicateOperationToJSON,
  V2beta1PredicateOperationToJSONTyped,
} from './V2beta1PredicateOperation';
import type { PredicateLongValues } from './PredicateLongValues';
import {
  PredicateLongValuesFromJSON,
  PredicateLongValuesFromJSONTyped,
  PredicateLongValuesToJSON,
  PredicateLongValuesToJSONTyped,
} from './PredicateLongValues';

/**
 * Predicate captures individual conditions that must be true for a resource
 * being filtered.
 * @export
 * @interface V2beta1Predicate
 */
export interface V2beta1Predicate {
  /**
   *
   * @type {V2beta1PredicateOperation}
   * @memberof V2beta1Predicate
   */
  operation?: V2beta1PredicateOperation;
  /**
   * Key for the operation (first argument).
   * @type {string}
   * @memberof V2beta1Predicate
   */
  key?: string;
  /**
   * Integer.
   * @type {number}
   * @memberof V2beta1Predicate
   */
  int_value?: number;
  /**
   * Long integer.
   * @type {string}
   * @memberof V2beta1Predicate
   */
  long_value?: string;
  /**
   * String.
   * @type {string}
   * @memberof V2beta1Predicate
   */
  string_value?: string;
  /**
   * Timestamp values will be converted to Unix time (seconds since the epoch)
   * prior to being used in a filtering operation.
   * @type {Date}
   * @memberof V2beta1Predicate
   */
  timestamp_value?: Date;
  /**
   *
   * @type {PredicateIntValues}
   * @memberof V2beta1Predicate
   */
  int_values?: PredicateIntValues;
  /**
   *
   * @type {PredicateLongValues}
   * @memberof V2beta1Predicate
   */
  long_values?: PredicateLongValues;
  /**
   *
   * @type {PredicateStringValues}
   * @memberof V2beta1Predicate
   */
  string_values?: PredicateStringValues;
}

/**
 * Check if a given object implements the V2beta1Predicate interface.
 */
export function instanceOfV2beta1Predicate(value: object): value is V2beta1Predicate {
  return true;
}

export function V2beta1PredicateFromJSON(json: any): V2beta1Predicate {
  return V2beta1PredicateFromJSONTyped(json, false);
}

export function V2beta1PredicateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1Predicate {
  if (json == null) {
    return json;
  }
  return {
    operation:
      json['operation'] == null ? undefined : V2beta1PredicateOperationFromJSON(json['operation']),
    key: json['key'] == null ? undefined : json['key'],
    int_value: json['int_value'] == null ? undefined : json['int_value'],
    long_value: json['long_value'] == null ? undefined : json['long_value'],
    string_value: json['string_value'] == null ? undefined : json['string_value'],
    timestamp_value:
      json['timestamp_value'] == null ? undefined : new Date(json['timestamp_value']),
    int_values:
      json['int_values'] == null ? undefined : PredicateIntValuesFromJSON(json['int_values']),
    long_values:
      json['long_values'] == null ? undefined : PredicateLongValuesFromJSON(json['long_values']),
    string_values:
      json['string_values'] == null
        ? undefined
        : PredicateStringValuesFromJSON(json['string_values']),
  };
}

export function V2beta1PredicateToJSON(json: any): V2beta1Predicate {
  return V2beta1PredicateToJSONTyped(json, false);
}

export function V2beta1PredicateToJSONTyped(
  value?: V2beta1Predicate | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operation: V2beta1PredicateOperationToJSON(value['operation']),
    key: value['key'],
    int_value: value['int_value'],
    long_value: value['long_value'],
    string_value: value['string_value'],
    timestamp_value:
      value['timestamp_value'] == null
        ? value['timestamp_value']
        : value['timestamp_value'].toISOString(),
    int_values: PredicateIntValuesToJSON(value['int_values']),
    long_values: PredicateLongValuesToJSON(value['long_values']),
    string_values: PredicateStringValuesToJSON(value['string_values']),
  };
}
